import { ParseKeys } from 'i18next'

export const helpersCarPhotosCamera: ParseKeys[] = [
  'helpersCarPhotosCamera.front view',
  'helpersCarPhotosCamera.left view',
  'helpersCarPhotosCamera.right view',
  'helpersCarPhotosCamera.rear view',
  'helpersCarPhotosCamera.under the hood',
  'helpersCarPhotosCamera.trunk',
  'helpersCarPhotosCamera.front interior',
  'helpersCarPhotosCamera.rear interior',
  'helpersCarPhotosCamera.dashboard',
]
